
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 55.905,
  height: 84.25,
  viewBox: "0 0 55.905 84.25"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_mobile_f7d5a6527f073f30__cls-1{fill:var(--theme-primary, #810ea9)}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icon_mobile_f7d5a6527f073f30__noun_Mobile_1682545",
  transform: "translate(-29.596 -19.25)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_mobile_f7d5a6527f073f30__Group_3686",
  transform: "translate(29.596 19.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon_mobile_f7d5a6527f073f30__Path_3534",
  d: "M80.7 19.25H34.391a4.8 4.8 0 0 0-4.791 4.795v74.66a4.8 4.8 0 0 0 4.795 4.795h34.59v-4.11H34.391a.687.687 0 0 1-.685-.685v-74.66a.687.687 0 0 1 .685-.685h46.315a.687.687 0 0 1 .685.685v61.646H85.5V24.045a4.8 4.8 0 0 0-4.8-4.795z",
  className: "icon_mobile_f7d5a6527f073f30__cls-1",
  transform: "translate(-29.596 -19.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_mobile_f7d5a6527f073f30__Path_3535",
  d: "M69.09 79.1a.687.687 0 0 1-.685.685h-5.56v4.11h5.56A4.8 4.8 0 0 0 73.2 79.1v-6.85h-4.11z",
  className: "icon_mobile_f7d5a6527f073f30__cls-1",
  transform: "translate(-17.297 .356)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_mobile_f7d5a6527f073f30__Path_3536",
  d: "M76.1 24.5H35v63.7h41.1zm-2.74 60.961H37.738V27.24h35.623z",
  className: "icon_mobile_f7d5a6527f073f30__cls-1",
  transform: "translate(-27.598 -17.308)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_mobile_f7d5a6527f073f30__Rectangle_2706",
  d: "M0 0h7.08v2.74H0z",
  className: "icon_mobile_f7d5a6527f073f30__cls-1",
  transform: "translate(24.412 74.661)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_mobile_f7d5a6527f073f30__Path_3537",
  d: "m46.377 58.109 6.039-6.039 6.039 6.039 2.904-2.909-6.039-6.039 6.039-6.039-2.906-2.906-6.038 6.044-6.039-6.039-2.906 2.906 6.039 6.039-6.038 6.034z",
  className: "icon_mobile_f7d5a6527f073f30__cls-1",
  transform: "translate(-24.463 -11.492)"
})))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"55.905\" height=\"84.25\" viewBox=\"0 0 55.905 84.25\">\r\n    <defs>\r\n        <style>\r\n            .cls-1{fill:var(--theme-primary, #810ea9)}\r\n        </style>\r\n    </defs>\r\n    <g id=\"noun_Mobile_1682545\" transform=\"translate(-29.596 -19.25)\">\r\n        <g id=\"Group_3686\" transform=\"translate(29.596 19.25)\">\r\n            <path id=\"Path_3534\" d=\"M80.7 19.25H34.391a4.8 4.8 0 0 0-4.791 4.795v74.66a4.8 4.8 0 0 0 4.795 4.795h34.59v-4.11H34.391a.687.687 0 0 1-.685-.685v-74.66a.687.687 0 0 1 .685-.685h46.315a.687.687 0 0 1 .685.685v61.646H85.5V24.045a4.8 4.8 0 0 0-4.8-4.795z\" class=\"cls-1\" transform=\"translate(-29.596 -19.25)\"/>\r\n            <path id=\"Path_3535\" d=\"M69.09 79.1a.687.687 0 0 1-.685.685h-5.56v4.11h5.56A4.8 4.8 0 0 0 73.2 79.1v-6.85h-4.11z\" class=\"cls-1\" transform=\"translate(-17.297 .356)\"/>\r\n            <path id=\"Path_3536\" d=\"M76.1 24.5H35v63.7h41.1zm-2.74 60.961H37.738V27.24h35.623z\" class=\"cls-1\" transform=\"translate(-27.598 -17.308)\"/>\r\n            <path id=\"Rectangle_2706\" d=\"M0 0H7.08V2.74H0z\" class=\"cls-1\" transform=\"translate(24.412 74.661)\"/>\r\n            <path id=\"Path_3537\" d=\"M46.377 58.109l6.039-6.039 6.039 6.039 2.904-2.909-6.039-6.039 6.039-6.039-2.906-2.906-6.038 6.044-6.039-6.039-2.906 2.906 6.039 6.039-6.038 6.034z\" class=\"cls-1\" transform=\"translate(-24.463 -11.492)\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon_mobile.f7d5a6527f073f306ae69ece9e689946.svg"),
        {
          React: SvgIconMobile,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      